var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#808085",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 3.5H6.99999V3C6.99999 2.44772 7.4477 2 7.99999 2H12C12.5523 2 13 2.44772 13 3V3.5H14.5C15.6046 3.5 16.5 4.39543 16.5 5.5V16C16.5 17.1046 15.6046 18 14.5 18H5.5C4.39543 18 3.5 17.1046 3.5 16V5.5C3.5 4.39543 4.39543 3.5 5.5 3.5ZM13 5.5V5H14.5C14.7761 5 15 5.22386 15 5.5V16C15 16.2761 14.7761 16.5 14.5 16.5H5.5C5.22386 16.5 5 16.2761 5 16V5.5C5 5.22386 5.22386 5 5.5 5H6.99999V5.5C6.99999 6.05228 7.4477 6.5 7.99999 6.5H12C12.5523 6.5 13 6.05228 13 5.5ZM8.49999 3.5V5H11.5V3.5H8.49999Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.8c340d26.svg";
export { ForwardRef as ReactComponent };